export const Languages = [
  {
    id: "Amharic",
    wotd: {
      wordObj: {
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FAmharic%2FAudio%2FDictionary%2FLocations%2FHospital.mp3?alt=media&token=ab01f54c-7866-46e7-8925-ffb0b92d56d3",
        word: "ሆስፒታል",
        description: "Hospital",
      },
      timeChanged: "2022-04-10T06:00",
    },
    alphabet: [],
    learnerCount: 824,
    name: "Amharic",
    region: "East Africa",
    availTrans: false,
    availMobile: true,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fethiopia.png?alt=media&token=f5a31081-2d57-4294-9e93-dd3e2d9da1b5",
    transId: "am",
    about:
      "Amharic is the language of the Amhara people , and the working language of Ethiopia. It is the most commonly spoken language in Ethiopia and second-most commonly spoken Semitic language in the world (after Arabic).",
    availWeb: true,
  },
  {
    id: "Arabic",
    region: "North Africa",
    availTrans: false,
    alphabet: [],
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fegypt.png?alt=media&token=96366e4a-2c71-4c23-9a8d-fba9475c9568",
    name: "Arabic",
    availMobile: false,
    transId: "ar",
    learnerCount: 1,
    wotd: {
      wordObj: {
        description: "Face",
        word: "وش",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FArabic%2FAudio%2FDictionary%2FBody%20Parts%2F%D9%88%D8%B4.mp3?alt=media&token=7ac4db52-84ba-400a-be7a-351ce7e87157",
      },
      timeChanged: "2022-02-10T06:00",
    },
    availWeb: false,
  },
  {
    id: "Bambara",
    region: "West Africa",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fmali.png?alt=media&token=f0933254-3512-4fa8-aaec-bd89290cc28e",
    learnerCount: 439,
    specialChars: ["ɛ", "ɔ"],
    wotd: {
      timeChanged: "2022-04-11T06:00",
      wordObj: {
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FBambara%2FAudio%2FPhrases%2FShopping%2FThere%20food%20at%20home.mp3?alt=media&token=ccf73aff-1f09-4ce4-872c-87d011b40681",
        description: "There's food at home",
        word: "Dumuni bɛ so.",
      },
    },
    about:
      "Bambara,  is a lingua franca and national language of Mali, spoken all throughout West Africa.",
    transId: " ",
    availTrans: false,
    alphabet: [],
    name: "Bambara",
    availWeb: true,
    availMobile: true,
  },
  {
    id: "Chichewa",
    transId: " ny",
    availMobile: false,
    wotd: ["Moni", "Hello"],
    availWeb: false,
    region: "East Africa",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fmalawi.png?alt=media&token=4c200f23-a70e-41b9-aa23-f53312d5fe09",
    specialChars: ["ŵ"],
    name: "Chichewa",
    about:
      "Chichewa (or Nyanja) is a Bantu language spoken in much of Southern and East Africa, namely the countries of Malawi and Zambia.",
    availTrans: false,
    alphabet: [],
    learnerCount: 0,
  },
  {
    id: "Coptic",
    name: "Coptic",
    about:
      "The Coptic language is the modern stage of the ancient Egyptian language. It is written in the Greek alphabet, except for seven letters.",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fegypt.png?alt=media&token=96366e4a-2c71-4c23-9a8d-fba9475c9568",
    alphabet: [],
    availWeb: true,
    wotd: {
      wordObj: {
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FCoptic%2FDictionary%2FAnimals%2FLion.mp3?alt=media&token=c4260b13-0b75-4675-870a-0748dd928a65",
        description: "Lion",
        word: "ⲙⲟⲩⲓ",
      },
      timeChanged: "2021-11-10T06:00",
    },
    transId: " ",
    specialChars: [""],
    learnerCount: 46,
    availTrans: false,
    region: "North Africa",
    availMobile: false,
  },
  {
    id: "Dioula",
    wotd: ["I ni ce Aw ni ce ", "Hello"],
    alphabet: [],
    region: "West Africa",
    availMobile: false,
    specialChars: [""],
    transId: " ",
    availTrans: false,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fburkina-faso.png?alt=media&token=bb0bbe50-1750-45b4-994e-88abf0588021",
    learnerCount: 0,
    availWeb: false,
    name: "Dioula",
    about:
      "Dioula is a Mandé language and lingua franca spoken all across West Africa, notably in Burkina Faso, Ivory Coast and Mali. It is written in the Latin script and the Arabic script, as well as in the indigenous N'Ko script.",
  },
  {
    id: "Ewe",
    wotd: ["Woé zɔ Miawoe zɔ", "Welcome"],
    specialChars: [""],
    region: "West Africa",
    about:
      "Ewe is a language spoken in Togo and southeastern Ghana. Ewe is part of a cluster of related languages commonly called Gbe.",
    learnerCount: 0,
    availTrans: false,
    name: "Ewe",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Ftogo.png?alt=media&token=a0abac6f-a363-4efd-a03c-452f64e210df",
    availWeb: false,
    availMobile: false,
    transId: " ",
    alphabet: [],
  },
  {
    id: "Fante",
    alphabet: [],
    specialChars: [""],
    availTrans: false,
    transId: " ",
    name: "Fante",
    learnerCount: 0,
    availMobile: false,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fghana.png?alt=media&token=fd6ba001-a4fe-4c0e-8603-6b44c840041e",
    region: "West Africa",
    availWeb: false,
    about:
      "Fante is one of the three principal Akan dialects. It is spoken in the central and southern regions of Ghana as well as in western Ghana.",
    wotd: ["", ""],
  },
  {
    id: "Fon",
    name: "Fon",
    alphabet: [],
    transId: " ",
    about: "Fon  is a Gbe language spoken mainly in Benin.",
    availTrans: false,
    availWeb: false,
    specialChars: [""],
    learnerCount: 0,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fbenin.png?alt=media&token=0a351574-812e-4f24-9123-a81c7406e7cc",
    availMobile: false,
    wotd: ["", ""],
    region: "West Africa",
  },
  {
    id: "Fulfulde",
    alphabet: [],
    learnerCount: 0,
    transId: " ",
    about:
      "Fula, also known as Fulani, Fulfulde, 𞤊𞤵𞤤𞤬𞤵𞤤𞤣𞤫, Pulaar 𞤆𞤵𞤤𞤢𞥄𞤪, and  Peul, is a Senegambian language spoken across West and Central Africa by more than 65 million people. ",
    specialChars: [""],
    availWeb: false,
    wotd: ["", ""],
    name: "Fula",
    availTrans: false,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fsenegal.png?alt=media&token=4e061c10-8237-4a20-8ac5-aa1b54bc418d",
    region: "West Africa",
    availMobile: false,
  },
  {
    id: "Gikuyu",
    specialChars: [""],
    wotd: ["", ""],
    alphabet: [],
    about:
      "Kikuyu or Gikuyu is a language of the Bantu family spoken primarily by the Kikuyu people of Kenya. Kikuyu is spoken in the area between Nyeri and Nairobi. The Kikuyu people usually identify their lands by the surrounding mountain ranges in Central Kenya which they call Kĩrĩnyaga.",
    name: "Gikuyu",
    region: "East Africa",
    transId: " ",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fkenya.png?alt=media&token=c4ab756b-bf4c-4ac2-83c8-b6a3f96a7273",
    availTrans: false,
    availWeb: false,
    learnerCount: 0,
    availMobile: false,
  },
  {
    id: "Haitian Creole",
    wotd: {
      wordObj: {
        word: "tig",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FHaitian%20Creole%2FAudio%2FDictionary%2FAnimals%2Ftig.wav?alt=media&token=43b4a28e-5303-447a-afae-4f8d8bb50b79",
        description: "Tiger",
      },
      timeChanged: "2022-04-10T06:00",
    },
    transId: "ht",
    region: "Carribean",
    about:
      "Haitian Creole is one of the two official languages of Haiti, where it is the native language of a majority of the population. Although its vocabulary is mostly taken from 18th-century French, its grammar and sentence structure is that of a West African language.",
    availWeb: true,
    specialChars: ["à"],
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fhaiti.png?alt=media&token=4dcebab3-b1a4-491a-8447-b1409f6fddd7",
    alphabet: [""],
    availTrans: false,
    name: "Haitian Creole",
    learnerCount: 288,
    availMobile: true,
  },
  {
    id: "Hausa",
    region: "West Africa",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fnigeria.png?alt=media&token=82c3a237-66b7-4cd5-8a05-8f684b3ca715",
    availWeb: true,
    availTrans: false,
    alphabet: [],
    wotd: {
      timeChanged: "2022-04-09T06:00",
      wordObj: {
        description: "Grey",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FHausa%2FAudio%2FDictionary%2FColors%2FMai%20ruwan%20toka(1).mp3?alt=media&token=9d9a63ec-5a00-4b33-998c-47d2fc5534f8",
        word: "mai ruwan toka",
      },
    },
    specialChars: ["ɗ", "ƙ", "ƴ"],
    availMobile: false,
    learnerCount: 260,
    name: "Hausa",
    about:
      "Hausa is a Chadic language spoken,all across West Africa, notably in Niger, Northern Nigeria, Chad, and Ghana. Hausa is a member of the Afroasiatic language family and is the most widely spoken Chadic language.",
    transId: "ha ",
  },
  {
    id: "Ibibo",
    specialChars: [""],
    learnerCount: 0,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fnigeria.png?alt=media&token=82c3a237-66b7-4cd5-8a05-8f684b3ca715",
    about:
      "Ibibio is the native language of the Ibibio people of Nigeria. Several words in the English, such as  buckaroo for example, which comes from the Ibibio word mbakara, come from the Ibibio language.",
    alphabet: [],
    wotd: ["", ""],
    name: "Ibibio",
    availTrans: false,
    availWeb: false,
    transId: " ",
    availMobile: false,
    region: "West Africa",
  },
  {
    id: "Igbo",
    learnerCount: 3595,
    availWeb: true,
    wotd: {
      wordObj: {
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FIgbo%2FAudio%2FDictionary%2FBody%20Parts%2Fknees.mp3?alt=media&token=27db752a-4193-4da2-8df9-a3b4241f242a",
        description: "Knees",
        word: "ikpere",
      },
      timeChanged: "2022-04-10T06:00",
    },
    availTrans: false,
    name: "Igbo",
    specialChars: ["ị", "ọ", "ṅ", "ụ"],
    newUserCount: 0,
    transId: "ig ",
    region: "West Africa",
    availMobile: true,
    alphabet: [
      { uppercase: "A", lowercase: "a" },
      { lowercase: "b", uppercase: "B" },
      { uppercase: "Ch", lowercase: "ch" },
      { lowercase: "d", uppercase: "D" },
      { uppercase: "E", lowercase: "e" },
      { uppercase: "F", lowercase: "f" },
      { lowercase: "g", uppercase: "G" },
      { lowercase: "gb", uppercase: "Gb" },
      { uppercase: "Gh", lowercase: "gh" },
      { lowercase: "gw", uppercase: "Gw" },
      { uppercase: "H", lowercase: "h" },
      { uppercase: "I", lowercase: "i" },
      { lowercase: "ị", uppercase: "Ị" },
      { lowercase: "j", uppercase: "J" },
      { uppercase: "K", lowercase: "k" },
      { uppercase: "Kp", lowercase: "kp" },
      { uppercase: "Kw", lowercase: "kw" },
      { lowercase: "l", uppercase: "L" },
      { lowercase: "m", uppercase: "M" },
      { uppercase: "N", lowercase: "n" },
      { uppercase: "Ñ", lowercase: "ñ" },
      { lowercase: "nw", uppercase: "Nw" },
      { uppercase: "Ny", lowercase: "ny" },
      { lowercase: "o", uppercase: "O" },
      { lowercase: "ọ", uppercase: "Ọ" },
      { lowercase: "p", uppercase: "P" },
      { lowercase: "r", uppercase: "R" },
      { lowercase: "s", uppercase: "S" },
      { lowercase: "sh", uppercase: "Sh" },
      { lowercase: "t", uppercase: "T" },
      { uppercase: "U", lowercase: "u" },
      { lowercase: "ụ", uppercase: "Ụ" },
      { lowercase: "v", uppercase: "V" },
      { lowercase: "w", uppercase: "W" },
      { lowercase: "y", uppercase: "Y" },
      { lowercase: "z", uppercase: "Z" },
    ],
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fnigeria.png?alt=media&token=82c3a237-66b7-4cd5-8a05-8f684b3ca715",
    about:
      "Igbo is a language spoken in southeast Nigeria, and is the native language of the Igbo people. ",
  },
  {
    id: "Kabyle",
    wotd: {
      wordObj: {
        word: "Azyam",
        description: "Dolphin",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FKabyle%2FDictionary%2FAnimals%2FAzyam.mp3?alt=media&token=2806ae53-822b-4ad3-a977-d3c328d16e67",
      },
      timeChanged: "2022-03-26T06:00",
    },
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Falgeria.png?alt=media&token=1649d5e0-39a4-4df0-ba32-7c193a948fce",
    availWeb: true,
    region: "North Africa",
    learnerCount: 19,
    about:
      "Kabyle, known natively as Taqbaylit (θɐqβæjlɪθ in the indegengeous Tifinagh script) is an Amazigh language spoken by the indigenous Amazigh Kabyle people in Algeria. It is written in latin, arabic, and Tifinagh script. Mandla teaches Kabyle with both the Latin and Tifinagh scripts. ",
    availMobile: false,
    alphabet: [],
    name: "Kabyle",
    availTrans: false,
  },
  {
    id: "Kassem",
    learnerCount: 56,
    availMobile: true,
    region: "West Africa",
    about:
      "Kassem is the language of the Kassena ethnic group of Ghana and Burkina Faso.",
    availTrans: "false",
    alphabet: [],
    wotd: {
      wordObj: {
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FKassena%2FAudio%2FDictionary%2FColors%2Fnasongo.mp3?alt=media&token=ce4d56e7-7738-431b-8eea-e2ce8cc90127",
        description: "Red",
        word: "Nasongo",
      },
      timeChanged: "2022-04-09T06:00",
    },
    transId: "",
    name: "Kassem",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fburkina-faso.png?alt=media&token=bb0bbe50-1750-45b4-994e-88abf0588021",
    availWeb: true,
  },
  {
    id: "Kinyarwanda",
    availMobile: true,
    availTrans: false,
    availWeb: true,
    name: "Kinyarwanda",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Frwanda.png?alt=media&token=4d813ff1-69fe-465e-95f2-6671edfc7c02",
    transId: " rw",
    specialChars: "",
    about:
      "Kinyarwanda is the most widely spoken language of Rwanda, where it is the official language along with English, Swahili and French. Kinyarwanda is mutually intelligible with Kirundi, spoken in Burundi. ",
    wotd: {
      wordObj: {
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FKinyarwanda%2FAudio%2FDictionary%2FAnimals%2F17%20Ikimonyo.mp3?alt=media&token=af6878a3-8ca2-4d11-a374-462246728a12",
        word: "Ikimonyo",
        description: "Ant",
      },
      timeChanged: "2022-04-10T06:00",
    },
    learnerCount: 266,
    alphabet: [],
    region: "East Africa",
  },
  {
    id: "Kirundi",
    transId: " rn",
    learnerCount: 0,
    name: "Kirundi",
    about:
      "Kirundi, is the most widely spoken language in Burundi where it is an official language, alongside French and English. It is also spoken in parts of Tanzania and the Democratic Republic of Congo. Kirundi is mutually intelligible with Kinyarwanda, spoken in Rwanda.",
    region: "East Africa",
    alphabet: [],
    wotd: ["", ""],
    availTrans: false,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fburundi.png?alt=media&token=53e73974-4573-44a3-96e3-9b8d43b39a62",
    availWeb: false,
    availMobile: false,
    specialChars: "",
  },
  {
    id: "Kongo",
    alphabet: [],
    name: "Kongo",
    specialChars: [""],
    availTrans: false,
    transId: " kg",
    about:
      "Kongo or Kikongo is one of the Bantu languages spoken by the Kongo people living in the Democratic Republic of the Congo, the Republic of the Congo, Angola and Gabon. Many of the slaves brought to the Americas were taken from this region. As a result, forms of the language are found in Brazil, Cuba, Puerto Rico, Colombia, the Dominican Republic and Haiti. It is also one of the sources of the Gullah language.",
    wotd: ["", ""],
    availMobile: false,
    learnerCount: 0,
    region: "Central Africa",
    availWeb: false,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fangola.png?alt=media&token=45c0635e-34b1-47b5-b44b-6e183715b501",
  },
  {
    id: "Lingala",
    wotd: {
      timeChanged: "2022-04-10T06:00",
      wordObj: {
        word: "mboka",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FLingala%2FAudio%2FDictionary%2FLocation%2Fmboka.mp3?alt=media&token=4f0e25e9-40e1-4849-8893-6c23f1ed56ca",
        description: "Village",
      },
    },
    specialChars: ["ɛ"],
    availTrans: false,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fdemocratic-republic-of-congo.png?alt=media&token=9dcbbd97-9395-4533-af41-7be02ebedc86",
    alphabet: [],
    availWeb: true,
    transId: " ",
    name: "Lingala",
    region: "Central Africa",
    learnerCount: 892,
    about:
      "Lingala is a Bantu language spoken throughout the Democratic Republic of the Congo, the Republic of the Congo, parts of Angola, the Central African Republic and South Sudan.",
    availMobile: true,
  },
  {
    id: "Malagasy",
    alphabet: [],
    availMobile: false,
    region: "Madagascar",
    availTrans: false,
    specialChars: [""],
    learnerCount: 0,
    name: "Malagasy",
    wotd: ["", ""],
    transId: " ",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fmadagascar.png?alt=media&token=10b1a831-f4e2-4fc2-a007-6dcf3bc8d00e",
    availWeb: false,
    about:
      "Malagasy the national and most widely spoken  language of Madagascar.  The Malagasy language is a member of the Austronesian language family, a grouping that includes languages from Indonesia, Malaysia, and the Philippines. The language's vocabulary borrows heavily from East African Bantu languages. ",
  },
  {
    id: "Mandinka",
    specialChars: [""],
    region: "West Africa",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fgambia.png?alt=media&token=e25278ad-9722-4a24-a1e3-bb3f55f7fc76",
    wotd: {
      wordObj: {
        description: "Dragon ",
        word: "Ninkinanko",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FMandinka%2FDragon%20.mp3?alt=media&token=1bd14ab0-0019-4971-b672-9831e3ee3b63",
      },
      timeChanged: "2022-04-10T06:00",
    },
    about:
      "A dialect of the Mandé language continuum, Mandinka is a widely spoken language in West Africa. On Mandla we teach Gambian Mandinka.",
    name: "Mandinka",
    availMobile: true,
    learnerCount: 375,
    availWeb: true,
  },
  {
    id: "Mooré",
    about:
      "The Mooré language is a Gur language of the Oti–Volta branch and one of two official regional languages of Burkina Faso. It is the language of the Mossi people.",
    wotd: {
      timeChanged: "2022-04-07T06:00",
      wordObj: {
        description: "Tuesday",
        word: "Talaato",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FMoor%C3%A9%2FAudio%2FDictionary%2FDays%20of%20the%20Week%2Ftalato.wav?alt=media&token=1e8ac5f5-d16e-4a00-8e8e-48e40f68e0cd",
      },
    },
    availWeb: true,
    learnerCount: 263,
    transId: " ",
    name: "Mooré",
    region: "West Africa",
    availMobile: true,
    alphabet: [
      { lowercase: "a", uppercase: "A" },
      { lowercase: "ã", uppercase: "Ã" },
      { lowercase: "b", uppercase: "B" },
      { lowercase: "d", uppercase: "D" },
      { lowercase: "e", uppercase: "E" },
      { uppercase: "Ẽ", lowercase: "ẽ\t" },
      { lowercase: "ɛ", uppercase: " Ɛ" },
      { lowercase: "f", uppercase: "F" },
      { lowercase: "g", uppercase: "G" },
      { uppercase: "H", lowercase: "h" },
      { lowercase: "i", uppercase: "I" },
      { lowercase: "ĩ", uppercase: "Ĩ " },
      { uppercase: "Ɩ", lowercase: "ɩ" },
      { lowercase: "k", uppercase: "K" },
      { uppercase: "L", lowercase: "l" },
      { lowercase: "m", uppercase: "M" },
      { lowercase: "n", uppercase: "N" },
      { lowercase: "o", uppercase: "O" },
      { lowercase: "õ\t", uppercase: "õ" },
      { uppercase: "P", lowercase: "p" },
      { uppercase: "R", lowercase: "r" },
      { lowercase: "s", uppercase: "S" },
      { lowercase: "t", uppercase: "T" },
      { lowercase: "u", uppercase: "U" },
      { lowercase: "ũ\t", uppercase: "Ũ" },
      { lowercase: "ʋ", uppercase: "Ʋ" },
      { lowercase: "v", uppercase: "V" },
      { uppercase: "W", lowercase: "w" },
      { lowercase: "y", uppercase: "Y" },
      { lowercase: "z", uppercase: "Z" },
    ],
    specialChars: ["ʼ", "ɛ", "ɩ", "ʋ"],
    availTrans: false,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fburkina-faso.png?alt=media&token=bb0bbe50-1750-45b4-994e-88abf0588021",
  },
  {
    id: "Northern Ndebele",
    wotd: {
      wordObj: { description: "", word: "", audio: "" },
      timeChanged: "",
    },
    region: "Southern Africa",
    availWeb: false,
    learnerCount: 0,
    availMobile: false,
    flag: "",
    specialChars: [""],
    name: "Northern Ndebele",
    about:
      "Northern Ndebele, also called Ndebele, isiNdebele, Zimbabwean Ndebele or North Ndebele, and formerly known as Matabele, is an African language belonging to the Nguni group of Bantu languages, spoken by the Northern Ndebele people, or Matabele, of Zimbabwe.",
  },
  {
    id: "Oromo",
    alphabet: [],
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fethiopia.png?alt=media&token=f5a31081-2d57-4294-9e93-dd3e2d9da1b5",
    learnerCount: 115,
    availWeb: true,
    specialChars: [""],
    region: "Horn of Africa",
    wotd: {
      wordObj: {
        description: "Fingers",
        word: "Quboota",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FOromo%2FAudio%2FDictionary%2FBody%20parts%2FFingers.mp3?alt=media&token=ecac0b60-e50e-4266-9287-5bea2f2e5724",
      },
      timeChanged: "2022-04-10T06:00",
    },
    availMobile: true,
    name: "Oromo",
    about:
      "Oromo is the most widely spoken of the Cushitic languages, a family which includes the Somali language. It is an official language in Ethiopia and is also spoken in Kenya, Somalia, Eritrea and Djibouti. ",
    transId: " ",
    availTrans: false,
  },
  {
    id: "Portuguese",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fangola.png?alt=media&token=45c0635e-34b1-47b5-b44b-6e183715b501",
    alphabet: [],
    region: "Continent Wide",
    specialChars: [""],
    name: "Portuguese",
    availTrans: false,
    learnerCount: 0,
    availMobile: false,
    transId: " pt-PT",
    about:
      "There are 5 Portuguese-speaking African countries: Angola, Cape Verde, Guinea-Bissau, Mozambique, and São Tomé and Príncipe.",
    wotd: ["", ""],
    availWeb: false,
  },
  {
    id: "Sepedi",
    learnerCount: 0,
    availMobile: false,
    availTrans: false,
    specialChars: [""],
    name: "Sepedi",
    transId: " st",
    about:
      "Sepedi is the language of the Pedi people, also known as the BaPedi. Sepedi is closely related to the official language of Setswana or Tswana, and the dialect of Setlokwa and the similar Sotho language, Sesotho sa Borwa, or Southern Sotho.",
    availWeb: false,
    wotd: ["", ""],
    alphabet: [],
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fsouth-africa.png?alt=media&token=1232b618-4096-4c07-89b0-ba9fb0e71e7b",
    region: "Southern Africa",
  },
  {
    id: "Sesotho",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Flesotho.png?alt=media&token=73c3c896-42ac-414c-969b-bc8478d33508",
    learnerCount: 0,
    availMobile: false,
    name: "Sesotho",
    region: "Southern Africa",
    about:
      "Sesotho is a Southern Bantu language of the Sotho-Tswana group, spoken primarily in Lesotho, South Africa, and Zimbabwe.",
    transId: " st",
    specialChars: [""],
    availTrans: false,
    availWeb: false,
    alphabet: [],
    wotd: ["", ""],
  },
  {
    id: "Shona",
    specialChars: [""],
    region: "Southern Africa",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fzimbabwe.png?alt=media&token=d1bda065-d38c-40c4-ada9-2180ddc38af1",
    alphabet: [],
    transId: "sn ",
    about:
      "Shona or chiShona is spoken by about 80% of the population of Zimbabwe.",
    name: "Shona",
    availWeb: true,
    wotd: {
      timeChanged: "2022-04-10T06:00",
      wordObj: {
        word: "dumbu",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FShona%2FAudio%2FDictionary%2FBody%20Parts%2FAbdomen.mp3?alt=media&token=e7a55159-05eb-4806-a235-ddf95ff479ab",
        description: "Abdomen",
      },
    },
    availMobile: true,
    learnerCount: 338,
    availTrans: false,
  },
  {
    id: "Somali",
    wotd: {
      timeChanged: "2022-04-09T06:00",
      wordObj: {
        description: "Snake",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FSomali%2FAudio%2FDictionary%2FAnimals%2FMas.mp3?alt=media&token=b538a502-38d3-42d4-a703-629dbff33820",
        word: "Mas",
      },
    },
    name: "Somali",
    transId: " so",
    alphabet: [],
    about:
      "Somali is the official language of Somalia and is also spoken in Djibouti and Ethiopia. It is a Cushitic language whose closest relative is Oromo, spoken in Ethiopia. ",
    specialChars: [],
    availMobile: false,
    learnerCount: 448,
    region: "Horn of Africa",
    availTrans: false,
    availWeb: true,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fsomalia.png?alt=media&token=886cf860-c761-49d3-9e30-59c6bdb9bdad",
  },
  {
    id: "Swahili",
    learnerCount: 1057,
    longAbout:
      "Swahili, also known by its native name Kiswahili, is a Bantu language and the native language of the Swahili people. It is a lingua franca of the African Great Lakes region and other parts of East and Southern Africa, including Tanzania, Uganda, Rwanda, Burundi, Kenya, some parts of Malawi, Somalia, Zambia, Mozambique, and the Democratic Republic of the Congo (DRC).Comorian, spoken in the Comoros Islands, is sometimes considered a dialect of Swahili, although other authorities consider it a distinct language.Sheng is a mixture of Swahili and English commonly spoken in Kenya and parts of Uganda. Swahili has been greatly influenced by Arabic; there are an enormous number of Arabic loanwords in the language, including the word swahili, from Arabic sawāḥilī (a plural adjectival form of an Arabic word meaning “of the coast”). The language dates from the contacts of Arabian traders with the inhabitants of the east coast of Africa over many centuries. Under Arab influence, Swahili originated as a lingua franca used by several closely related Bantu-speaking tribal groups. The exact number of Swahili speakers, be they native or second-language speakers, is unknown and is a matter of debate. Various estimates have been put forward, which vary widely, ranging from 50 million to 100 million. Swahili serves as a national language of the DRC, Kenya, Tanzania, and Uganda. Shikomor, an official language in Comoros and also spoken in Mayotte (Shimaore), is related to Swahili.[11] Swahili is also one of the working languages of the African Union and of the Southern African Development Community. It is officially recognised as a lingua franca of the East African Community.In 2018, South Africa legalized the teaching of Swahili in South African schools as an optional subject to begin in 2020.Botswana followed in 2020, and Namibia plans to introduce the language as well.",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fkenya.png?alt=media&token=c4ab756b-bf4c-4ac2-83c8-b6a3f96a7273",
    wotd: {
      timeChanged: "2022-04-10T06:00",
      wordObj: {
        description: "Green",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FSwahili%2FAudio%2FDictionary%2FColors%2FKijani.mp3?alt=media&token=fefdae48-7b9f-4522-9726-a6f2d2043c10",
        word: "Kijani",
      },
    },
    availTrans: false,
    availMobile: true,
    alphabet: [],
    availWeb: true,
    about:
      "Swahili, also known by its native name Kiswahili, is a Bantu language and the lingua franca of East and Southern Africa. It is spoken in Tanzania, Uganda, Rwanda, Burundi, Kenya, some parts of Malawi, Somalia, Zambia, Mozambique, and the Democratic Republic of the Congo.",
    name: "Swahili",
    region: "East Africa",
    specialChars: [],
    transId: " sw",
  },
  {
    id: "Swazi",
    specialChars: [""],
    availMobile: false,
    wotd: ["", ""],
    availWeb: false,
    name: "Swazi",
    learnerCount: 0,
    region: "Southern Africa",
    alphabet: [],
    transId: " ",
    about:
      "The Swati or siSwati language is a Bantu language of the Nguni group spoken in Eswatini and South Africa by the Swati people. The number of speakers is estimated to be in the region of 2.4 million. The language is taught in Eswatini and some South African schools in Mpumalanga, particularly former KaNgwane areas. Siswati is an official language of Eswatini (along with English), and is also one of the eleven official languages of South Africa.",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fswaziland.png?alt=media&token=11b03b4d-6c56-4d95-986e-320113b60276",
    availTrans: false,
  },
  {
    id: "Tarifit",
    wotd: { timeChanged: "", description: "", word: "" },
    availTrans: false,
    learnerCount: 0,
    availWeb: false,
    region: "North Africa",
    about:
      "Tarifit also known as Rif(f)Ian  (Tifinagh: ⵜⴰⵔⵉⴼⵉⵢⵜ) is a Moroccan Zenati Amazigh language. It is spoken natively by the millions of indigenous Amazigh people of Morocco and Algeria as well as by expatriate communities.",
    alphabet: [],
    availMobile: false,
    name: "Tarifit",
  },
  {
    id: "Tigrinya",
    name: "Tigrinya",
    specialChars: [""],
    availMobile: false,
    region: "Horn of Africa",
    availTrans: false,
    alphabet: [],
    wotd: ["", ""],
    learnerCount: 0,
    availWeb: false,
    about:
      "Tigrinya, also spelt Tigrigna, is spoken in Ethiopia as an official working language and in Eritrea as the national language. There is also a large Tigrinya speaking population in Israel, Sudan, Saudi Arabia and other countries. It is closely related to Amharic, spoken in Ethiopia, and Tigre, spoken in Eritrea, and is distantly related to other Semitic languages such as Arabic and Hebrew. Tigrinya is written in the Ge’ez script, in which each symbol represents both a consonant and a vowel.",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Feritrea.png?alt=media&token=02d1c640-6bc0-4932-ac9e-587e9d2a25a6",
    transId: " ",
  },
  {
    id: "Tshiluba",
    transId: " ",
    region: "Central Africa",
    availTrans: false,
    specialChars: [""],
    wotd: ["", ""],
    learnerCount: 0,
    name: "Tshiluba",
    availWeb: false,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fdemocratic-republic-of-congo.png?alt=media&token=9dcbbd97-9395-4533-af41-7be02ebedc86",
    alphabet: [],
    availMobile: false,
    about:
      "Tshiluba is a Bantu language of Central Africa and a national language of the Democratic Republic of the Congo, alongside Lingala, Swahili, and Kikongo. ",
  },
  {
    id: "Tswana",
    transId: " tn",
    availMobile: false,
    availWeb: false,
    alphabet: [],
    wotd: ["", ""],
    region: "Southern Africa",
    availTrans: false,
    learnerCount: 0,
    name: "Tswana",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fbotswana.png?alt=media&token=81a87fb9-5781-4a2a-86a8-58f153ba65ca",
    about:
      "Tswana or Setswana is the national language of Botswana, and one of the official languages of South Africa. It is also spoken in Namibia and Zimbabwe. ",
    specialChars: [""],
  },
  {
    id: "Twi",
    alphabet: [],
    availWeb: true,
    transId: "tw",
    newUserCount: 0,
    learnerCount: 3164,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fghana.png?alt=media&token=fd6ba001-a4fe-4c0e-8603-6b44c840041e",
    availTrans: true,
    about:
      "Twi is a dialect of the Akan language and one of the most widely spoken languages in West Africa. About 80% of the Ghanaian population speaks Twi as a first or second language.",
    availMobile: true,
    region: "West Africa",
    name: "Twi",
    wotd: {
      wordObj: {
        description: "Skull",
        word: "tikwankora",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FTwi%2FAudio%2FDictionary%2FBody%20Parts%2Ftikwankora.mp3?alt=media&token=75def25a-df41-46c2-8cec-8546965df9e2",
      },
      timeChanged: "2022-04-10T06:00",
    },
  },
  {
    id: "Umbundu",
    transId: " ",
    availWeb: false,
    about:
      "Umbundu is a Bantu language spoken in southwestern Africa. It is the language of the Ovimbundu, an ethnic group constituting a third of Angola's population.",
    availMobile: false,
    availTrans: false,
    specialChars: [""],
    learnerCount: 0,
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fangola.png?alt=media&token=45c0635e-34b1-47b5-b44b-6e183715b501",
    region: "Central Africa",
    wotd: ["", ""],
    alphabet: [],
    name: "Umbundu",
  },
  {
    id: "Wolof",
    name: "Wolof",
    region: "West Africa",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fsenegal.png?alt=media&token=4e061c10-8237-4a20-8ac5-aa1b54bc418d",
    about:
      "The Wolof people make up only about 40% of the Senegalese population, but at least 80% of the country speaks Wolof as either a first or second language. Technically, the official language is French, but Wolof is commonly used as a lingua franca in a country of 36 languages. Wolof is also spoken in The Gambia, where it borrows heavily from English - in contrast, Senegalese Wolof is influenced more by French.",
    learnerCount: 248,
    specialChars: ["à", "ó", "é", "ε"],
    availTrans: false,
    transId: " wo",
    availWeb: true,
    alphabet: [],
    availMobile: true,
    wotd: {
      wordObj: {
        word: "Muss",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FWolof%2FAudio%2FAnimals%2FCat.mp3?alt=media&token=86794889-6b63-4853-852c-fd0d9d3814f7",
        description: "Cat",
      },
      timeChanged: "2022-04-10T06:00",
    },
  },
  {
    id: "Xhosa",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fsouth-africa.png?alt=media&token=1232b618-4096-4c07-89b0-ba9fb0e71e7b",
    availWeb: true,
    wotd: {
      wordObj: {
        description: "Intaka",
        word: "Bird",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FXhosa%2FAudio%2FAnimals%2FBird.mp3?alt=media&token=c34f8d90-253c-45b4-869d-4c83828d6080",
      },
      timeChanged: "2022-04-10T06:00",
    },
    availTrans: false,
    region: "Southern Africa",
    availMobile: true,
    specialChars: [""],
    name: "Xhosa",
    alphabet: [],
    transId: " xh",
    about:
      "Xhosa is one of 11 official languages of South Africa and is spoken mostly in Eastern Cape Province and Transkei. It is also spoken in Botswana and Lesotho. It is closely related to Zulu, Swati and Ndebele and all four languages are mutually understandable. Xhosa is both a tonal language and a click language. It has two tones, high and low, and three different types of click sounds.",
    learnerCount: 488,
  },
  {
    id: "Yoruba",
    region: "West Africa",
    newUserCount: 0,
    availMobile: true,
    alphabet: [],
    learnerCount: 4657,
    transId: " yo",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fnigeria.png?alt=media&token=82c3a237-66b7-4cd5-8a05-8f684b3ca715",
    wotd: {
      wordObj: {
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FYoruba%2FAudio%2FDictionary%2FBodyParts%2Fe%CC%80ji%CC%81ka%CC%81.mp3?alt=media&token=95f50175-b3d8-404b-985f-086f528b9ec7",
        word: " èjìká",
        description: "Shoulder",
      },
      timeChanged: "2022-04-10T06:00",
    },
    specialChars: ["à", "ẹ", "ọ", "ṣ", "ù"],
    availTrans: false,
    availWeb: true,
    about:
      "Yoruba is one of West Africa’s most spoken languages . It is mostly spoken in southwestern Nigeria and in east Benin. Yoruba vocabulary is also used throughout the Yoruba diaspora in South America and the Caribbean.",
    longAbout:
      "The Yoruba dialect continuum itself consists of several dialects. The various Yoruba dialects in the Yorubaland of Nigeria can be classified into five major dialect areas: Northwest, Northeast, Central, Southwest and Southeast.[10] Clear boundaries cannot be drawn, peripheral areas of dialectal regions often having some similarities to adjoining dialects. North-West Yoruba (NWY) Egba, Ibadan, Egbado/Yewa, Ọyọ, Western Ogun, Lagos/Eko. North-East Yoruba (NEY) Yagba, Owe, Ijumu, Oworo, Gbede, Abunu. Central Yoruba (CY) Igbomina, Ijesha, Ifẹ, Ekiti, Akurẹ, Ẹfọn. South-East Yoruba (SEY) Ikale, Ilaje, Ondo City, Ọwọ, Idanre, Akoko, Remo, Ijẹbu. South-West Yoruba (SWY) Ketu, Awori, Sakété, Ifè (Togo), Idasha, Ipokia/Anago. North-West Yoruba is historically a part of the Ọyọ Empire. In NWY dialects, Proto-Yoruba velar fricative /ɣ/ and labialized voiced velar /gʷ/ have merged into /w/; the upper vowels /ɪ/ and /ʊ/ were raised and merged with /i/ and /u/, just as their nasal counterparts, resulting in a vowel system with seven oral and three nasal vowels. South-East Yoruba was probably associated with the expansion of the Benin Empire after c. 1450.[11] In contrast to NWY, lineage and descent are largely multilineal and cognatic, and the division of titles into war and civil is unknown. Linguistically, SEY has retained the /ɣ/ and /gw/ contrast, while it has lowered the nasal vowels /ĩ/ and /ʊ̃/ to /ɛ̃/ and /ɔ̃/, respectively. SEY has collapsed the second and third person plural pronominal forms; thus, àn án wá can mean either 'you (pl.) came' or 'they came' in SEY dialects, whereas NWY for example has ẹ wá 'you (pl.) came' and wọ́n wá 'they came', respectively. The emergence of a plural of respect may have prevented the coalescence of the two in NWY dialects. Central Yoruba forms a transitional area in that the lexicon has much in common with NWY, and it shares many ethnographical features with SEY. Its vowel system is the least innovative (most stable) of the three dialect groups, having retained nine oral-vowel contrasts and six or seven nasal vowels, and an extensive vowel harmony system. Peculiar to Central and Eastern (NEY, SEY) Yoruba also, is the ability to begin words with the vowel [ʊ:] which in Western Yoruba has been changed to [ɪ:] Literary Yoruba, also known as Standard Yoruba, Yoruba koiné, and common Yoruba, is a separate member of the dialect cluster. It is the written form of the language, the standard variety learned at school and that spoken by newsreaders on the radio. Standard Yoruba has its origin in the 1850s, when Samuel A. Crowther, the first native African Anglican bishop, published a Yoruba grammar and started his translation of the Bible. Though for a large part based on the Ọyọ and Ibadan dialects, Standard Yoruba incorporates several features from other dialects. It also has some features peculiar to itself, for example, the simplified vowel harmony system, as well as foreign structures, such as calques from English which originated in early translations of religious works. Because the use of Standard Yoruba did not result from some deliberate linguistic policy, much controversy exists as to what constitutes 'genuine Yoruba', with some writers holding the opinion that the Ọyọ dialect is the most \"pure\" form, and others stating that there is no such thing as genuine Yoruba at all. Standard Yoruba, the variety learned at school and used in the media, has nonetheless been a powerful consolidating factor in the emergence of a common Yoruba identity.",
    name: "Yoruba",
  },
  {
    id: "Zulu",
    flag: "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/flags%2Fsouth-africa.png?alt=media&token=1232b618-4096-4c07-89b0-ba9fb0e71e7b",
    region: "Southern Africa",
    about:
      "The Zulu language is spoken in the KwaZulu-Natal Province in South Africa. It has the highest number of native speakers of all of South Africa's 11 official languages, and is also spoken in Swaziland, Botswana, Lesotho, Malawi and Mozambique.",
    name: "Zulu",
    learnerCount: 424,
    transId: " zu",
    availTrans: false,
    wotd: {
      timeChanged: "2022-04-06T06:00",
      wordObj: {
        description: "Toenails",
        word: "nezezinzwane",
        audio:
          "https://firebasestorage.googleapis.com/v0/b/mandla-demo.appspot.com/o/Languages%2FZulu%2FAudio%2FDictionary%2FBody%20Parts%2FNezezinzwane.mp3?alt=media&token=dfe5fe9d-6546-4fdc-bf09-df5d6c17bb51",
      },
    },
    availWeb: true,
    alphabet: [],
    availMobile: false,
    specialChars: [""],
  },
];
